export const INELIGIBLE_WARNING_TEXT =
  "To access Capital One Travel you need an eligible credit card associated with this account.";

export const BAD_STATUS_WARNING_TEXT =
  "To see if you can access Capital One Travel, you’ll need to give us a call.";

export const INELIGIBLE_BUTTON_LABEL = "Discover Eligible Credit Cards";

export const BAD_STATUS_BUTTON_LABEL = "Contact Us";

export const BREX_RELAUNCH_FAILED_TEXT =
  "Your session has ended. Please close and reopen Travel in Brex.";
